/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react'
import { Login, LoginSuccessPayload } from './Login'
import { useDispatch } from 'react-redux';
import * as auth from '../redux/AuthRedux'
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { TwoFactorMethod } from '../../../../app/modules/common/enum/two-factor-method'
export function LoginPage() {

  const dispatch = useDispatch()
  const history = useHistory();

  const {
    setEmail,
    setToken,
    setTwoFactorMethod,
    setRememberMe,
    setRefreshToken,
    setLongTermToken,
    setDisplayName,
  } = useContext(AuthContext);


  const handleLogin = (
    payload: LoginSuccessPayload,
    email: string,
    rememberMe: boolean
  ) => {
    const {
      token,
      longTermToken,
      refreshToken,
      twoFactorEnabled,
      twoFactorConnected,
      twoFactorMethod,
      name,
    } = payload;

    setEmail(email);
    setToken(token ?? '');
    setTwoFactorMethod(twoFactorMethod);
    setRememberMe(rememberMe);
    setRefreshToken(refreshToken ?? '');
    setLongTermToken(longTermToken ?? '');
    setDisplayName(name ?? email);

    if (twoFactorEnabled === null) {
      const accessToken = rememberMe && longTermToken ? longTermToken : token ?? '';
      dispatch(
        auth.actions.login(
          accessToken,
          refreshToken ?? '',
          rememberMe,
          longTermToken,
          name ?? email
        )
      );
      return;
    }

    if (twoFactorEnabled === true) {
      if (twoFactorConnected === true || twoFactorMethod === TwoFactorMethod.Email) {
        history.push('/auth/login-2fa');
        return;
      }
      history.push('/auth/setup-2fa')
      return;
    }

    if (twoFactorEnabled === false) {
      history.push('/auth/option-2fa');
      return;
    }
  }

  return (<Login handleLogin={handleLogin} />);
}
